// migrated 1:1 from @nexato/nx-core-module, #688
import { Component, Input, ViewChild, ViewContainerRef, Inject, Type, AfterViewInit, TemplateRef, Output, EventEmitter, OnDestroy, ComponentRef, OnChanges, SimpleChanges } from "@angular/core";
import { ACTIVITY_COMPONENTS, ActivityComponent } from "../components/activityComponent";
import { outputToObservable } from "@angular/core/rxjs-interop";
import { Subscription } from "rxjs";

@Component({
  selector: '[app-activity-renderer]',
  template: `
    <div class="activity-inner flex w-full">
      <div class="w-8 flex flex-shrink-0 items-start justify-center mr-1 z-10"
        [ngClass]="{'pt-[3px]': getCustomIndicatorTemplate()}">
        <!-- <span *ngIf="!getCustomIndicatorTemplate()" class="absolute left-0 top-2 w-2 h-2 bg-gray-400 rounded-full"></span> -->
        <div class="defaultIcon"
          *ngIf="!getCustomIndicatorTemplate()"
          [ngClass]="{'pt-[5px]': !getCustomIndicatorTemplate()}">
          <svg
            width="10" height="10" viewBox="0 0 10 10" fill="none">
            <circle cx="5" cy="5" r="4" fill="#f3f4f6" stroke="#d1d5db" stroke-width="1"/>
            <circle cx="5" cy="5" r="1.5" fill="#6b7280"/>
        </svg>
        </div>
        <ng-container *ngIf="getCustomIndicatorTemplate()" [ngTemplateOutlet]="getCustomIndicatorTemplate()"></ng-container>
      </div>
      <div class="flex-1">
        <ng-container #dynamicComponent></ng-container>
      </div>
    </div>
        <!--
    <div class="ml-4 pt-[2px]">

    </div> -->
  `
})
export class ActivityRendererComponent implements AfterViewInit, OnDestroy, OnChanges {

  @Output() reloaded = new EventEmitter<void>();

  @Input() activity!: any;
  @Input() ownerId?: string;
  @Input() index!: number;
  @Input() isFirst!: boolean;
  @Input() isLast!: boolean;
  @ViewChild('dynamicComponent', { read: ViewContainerRef })
  private container!: ViewContainerRef;
  private componentRef?: ComponentRef<ActivityComponent>;
  private reloadSubscription?: Subscription;

  constructor(
    @Inject(ACTIVITY_COMPONENTS) private components: Map<string, Type<ActivityComponent>>
  ) {}

  ngAfterViewInit() {
    this.renderComponent();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activity'] && !changes['activity'].firstChange && this.componentRef) {
      this.componentRef.setInput('activity', this.activity);
    }
    if (changes['ownerId'] && !changes['ownerId'].firstChange && this.componentRef) {
      this.componentRef.setInput('ownerId', this.ownerId);
    }
  }

  ngOnDestroy() {
    this.reloadSubscription?.unsubscribe();
  }

  private renderComponent() {
    const componentType = this.components.get(this.activity.activityType);
    if (!componentType) {
      // console.warn("No component found for activity type:", this.activity.activityType);
      return;
    }

    this.componentRef = this.container.createComponent(componentType);
    this.componentRef.setInput('activity', this.activity);
    if (this.ownerId !== undefined) {
      this.componentRef.setInput('ownerId', this.ownerId);
    }

    const instance = this.componentRef.instance as any;
    if ('reloaded' in instance && instance.reloaded) {
      this.reloadSubscription = outputToObservable(instance.reloaded).subscribe(() => this.reloaded.emit());
    }
  }

  getCustomIndicatorTemplate(): TemplateRef<any> | null {
    return this.componentRef?.instance?.getIndicatorTemplate?.() || null;
  }
}
